import { render, staticRenderFns } from "./order-booked-card.vue?vue&type=template&id=13af74f2"
import script from "./order-booked-card.vue?vue&type=script&lang=js"
export * from "./order-booked-card.vue?vue&type=script&lang=js"
import style0 from "./order-booked-card.vue?vue&type=style&index=0&id=13af74f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports